import { render } from "./AssessmentPrompt.vue?vue&type=template&id=02f0836e&scoped=true"
import script from "./AssessmentPrompt.vue?vue&type=script&lang=js"
export * from "./AssessmentPrompt.vue?vue&type=script&lang=js"

import "./AssessmentPrompt.vue?vue&type=style&index=0&id=02f0836e&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-02f0836e"

export default script